export const domainSettingColumns = {
    admin: {
        action: {},
        createBy: {},
        groupName: {},
        servername: {},
        _id: {},
        appProfileName: {},
        serviceGroupName: {},
        useOriginPolicy: {},
        usedOriginPolicies: {},
        origins: {},
        scheme: {},
        httpPort: {},
        httpsPort: {},
        redirecthttps: {},
        redirectHttpCode: {},
        useHttp2: {},
        useHsts: {},
        hasSystemCert: {},
        useSystemCert: {},
        sslProvider: {},
        keypairname: {},
        isAllowOCSP: {},
        usedWafRules: {},
        isUsedWafRules: {},
        isUseOwasp: {},
        owaspRuleName: {},
        tags: {},
        description: {},
        originscheme: {},
        portMappingType: {},
        originPort: {},
        setCustomHostHeader: {},
        customHostHeader: {},
        errorHtmlPageName: {},
        upstreamTimeout: {},
        isEnabledCompressionToOrigin: {},
        isEnabledUpstreamHttp11: {},
        isInsertRidHeaderToOrigin: {},
        isAcceptHttpV1: {},
        websocketPath: {},
        proxyBufferSize: {},
        customVariables: {},
        proxySetHeader: {},
        isUpgradeInsecureRequest: {},
        maxUploadSize: {},
        rewriteUrlRules: {},
        cacheUrlRules: {},
        cacheKey: {},
        isEnforceProtect: {},
        proxyCacheIgnoreArgs: {},
        cusCachepath: {},
        cusCachefile: {},
        forceCusCachePath: {},
        forceCusCacheFile: {},
        cusNoncachepath: {},
        cusNonachefile: {},
        cusFollowCachePath: {},
        cusFollowCacheFile: {},
        cusCachepathExp: {},
        cusCachepathSrvexp: {},
        cusCachefileExp: {},
        cusCachefileSrvexp: {},
        defCachefileExp: {},
        defCachefileSrvexp: {},
        defCachefile: {},
        defNoncachepath: {},
        currentCname: {},
        cnameInfo: {},
        createdDate: {},
        modifiedDate: {},
        status: {},
        objectLog: {}
    },
    normalUser: {
        action: {},
        createBy: {},
        groupName: {},
        servername: {},
        _id: {},
        appProfileName: {},
        serviceGroupName: {},
        origins: {},
        useOriginPolicy: {},
        usedOriginPolicies: {},
        scheme: {},
        httpPort: {},
        httpsPort: {},
        redirecthttps: {},
        redirectHttpCode: {},
        useHsts: {},
        hasSystemCert: {},
        useSystemCert: {},
        sslProvider: {},
        keypairname: {},
        isAllowOCSP: {},
        usedWafRules: {},
        isUsedWafRules: {},
        isUseOwasp: {},
        owaspRuleName: {},
        tags: {},
        description: {},
        originscheme: {},
        portMappingType: {},
        originPort: {},
        setCustomHostHeader: {},
        customHostHeader: {},
        errorHtmlPageName: {},
        upstreamTimeout: {},
        isEnabledCompressionToOrigin: {},
        isEnabledUpstreamHttp11: {},
        isInsertRidHeaderToOrigin: {},
        isAcceptHttpV1: {},
        websocketPath: {},
        proxyBufferSize: {},
        customVariables: {},
        proxySetHeader: {},
        isUpgradeInsecureRequest: {},
        maxUploadSize: {},
        rewriteUrlRules: {},
        cacheUrlRules: {},
        cacheKey: {},
        proxyCacheIgnoreArgs: {},
        cusCachepath: {},
        cusCachefile: {},
        forceCusCachePath: {},
        forceCusCacheFile: {},
        cusNoncachepath: {},
        cusNonachefile: {},
        cusFollowCachePath: {},
        cusFollowCacheFile: {},
        cusCachepathExp: {},
        cusCachepathSrvexp: {},
        cusCachefileExp: {},
        cusCachefileSrvexp: {},
        defCachefileExp: {},
        defCachefileSrvexp: {},
        defCachefile: {},
        defNoncachepath: {},
        currentCname: {},
        cnameInfo: {},
        createdDate: {},
        modifiedDate: {},
        status: {},
        objectLog: {}
    }
}


// WEBPACK FOOTER //
// ./src/libs/exportFileColumns.js